import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=580b9680&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports